import { Phone, MessageCircle, MapPin, Mail } from "lucide-react";
import { PHONE, TEL_URL, WHATSAPP_URL } from "@/lib/api";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0A0E17] border-t border-white/10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-6">
            <p className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-6">
              Let&apos;s Travel
            </p>
            <h2 className="font-serif font-light text-5xl md:text-7xl text-white leading-[1.05] tracking-tight">
              Your road to Keonjhar
              <br />
              <span className="italic text-[#D95D39]">starts with a call.</span>
            </h2>
            <div className="mt-10 flex flex-wrap gap-4">
              <a
                href={TEL_URL}
                data-testid="footer-call-button"
                className="bg-[#D95D39] hover:bg-[#E27D60] text-white px-8 py-4 flex items-center gap-3 transition-colors"
              >
                <Phone className="w-4 h-4" />
                <span className="tracking-wider">Call {PHONE}</span>
              </a>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-whatsapp-button"
                className="border border-[#2C5F2D] bg-[#2C5F2D]/20 hover:bg-[#2C5F2D] text-white px-8 py-4 flex items-center gap-3 transition-colors"
              >
                <MessageCircle className="w-4 h-4" />
                <span className="tracking-wider">WhatsApp</span>
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.25em] text-gray-500 mb-5">
              Contact
            </p>
            <ul className="space-y-3 text-gray-300">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-1 text-[#D4AF37]" />
                <a href={TEL_URL} className="hover:text-white">{PHONE}</a>
              </li>
              <li className="flex items-start gap-3">
                <MessageCircle className="w-4 h-4 mt-1 text-[#D4AF37]" />
                <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="hover:text-white">
                  WhatsApp: {PHONE}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-1 text-[#D4AF37]" />
                <span>Harichandanpur, Keonjhar, Odisha</span>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-1 text-[#D4AF37]" />
                <span>booking@amyeetravels.in</span>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.25em] text-gray-500 mb-5">
              Explore
            </p>
            <ul className="space-y-3">
              <li><Link to="/" className="text-gray-300 hover:text-white">Home</Link></li>
              <li><Link to="/packages" className="text-gray-300 hover:text-white">Tour Packages</Link></li>
              <li><Link to="/#booking" className="text-gray-300 hover:text-white">Book a Cab</Link></li>
              <li>
                <Link to="/admin/bookings" data-testid="footer-admin-link" className="text-gray-500 hover:text-[#D4AF37] text-sm">
                  Admin
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Amyee Travels · Harichandanpur, Keonjhar
          </p>
          <p className="text-gray-600 text-xs tracking-widest uppercase">
            Trusted rides across Odisha
          </p>
        </div>
      </div>
    </footer>
  );
};
